module.exports = __webpack_public_path__ + "static/media/about-16.0dde88c1.webp";